'use client';

import type { RenderLeafProps } from 'slate-react';
import styled from 'styled-components';

const Leaf = (props: RenderLeafProps) => {
  const { attributes, children, leaf } = props;

  let child = children;
  if (leaf.bold) {
    child = <strong {...attributes}>{child}</strong>;
  }

  if (leaf.italic) {
    child = <em {...attributes}>{child}</em>;
  }

  if (leaf.marker) {
    child = (
      <mark {...attributes} style={{ backgroundColor: '#fcd430' }}>
        {child}
      </mark>
    );
  }

  if (leaf.underline) {
    child = (
      <u {...attributes} style={{ textUnderlineOffset: 8 }}>
        {child}
      </u>
    );
  }

  if (leaf['line-through']) {
    child = <LineThrough {...attributes}>{child}</LineThrough>;
  }

  // TODO: remove after mapper removed
  if ((leaf as any).hardBreak) {
    child = (
      <>
        {child}
        <br className="last:hidden" />
      </>
    );
  }

  return child;
};

export default Leaf;

const LineThrough = styled.span`
  position: relative;
  white-space: nowrap;

  &:after {
    content: '';
    border-top: 1px solid #9696a0;
    position: absolute;
    right: 0;
    top: 50%;
    left: 0;
  }
`;
